import { gql } from "@apollo/client";

export const get_wallet_transactions_by_clinic = gql`
  query GetWalletTransactionsByClinic(
    $clinicCode: String!
    $skip: Int
    $take: Int
    $fromDate: String
    $toDate: String
  ) {
    getWalletTransactionsByClinic(
      clinicCode: $clinicCode
      skip: $skip
      take: $take
      fromDate: $fromDate
      toDate: $toDate
    ) {
      data {
        transactionNumber
        type
        status
        balance
        comment
        cash
        detailBalance
        accountbalance
        mainAccountName
        sender_id
        senderName
        senderPhone
        recipient_id
        recipientName
        recipientPhone
        createddate_myanmar
        ClinicCode
        ClinicName
      }
      totalCount
    }
  }
`;

export const get_wallet_summary = gql`
  query GetWalletSummary($clinicCode: String!, $fromDate: String, $toDate: String) {
    getWalletSummary(clinicCode: $clinicCode, fromDate: $fromDate, toDate: $toDate) {
      totalIn
      totalOut
      transactionCount
      balance
    }
  }
`;

export const get_wallet_transactions = gql`
  query GetWalletTransactions(
    $clinicCode: String!
    $skip: Int
    $take: Int
    $fromDate: String
    $toDate: String
  ) {
    getWalletTransactions(
      clinicCode: $clinicCode
      skip: $skip
      take: $take
      fromDate: $fromDate
      toDate: $toDate
    ) {
      data {
        transactionNumber
        type
        status
        balance
        comment
        cash
        detailBalance
        accountbalance
        mainAccountName
        sender_id
        senderName
        senderPhone
        recipient_id
        recipientName
        recipientPhone
        createddate_myanmar
        ClinicCode
        ClinicName
      }
      totalCount
    }
  }
`;

export interface WalletTransactionRow {
  transactionNumber: string;
  type?: string | null;
  status?: string | null;
  balance?: number | null;
  comment?: string | null;
  cash?: number | null;
  detailBalance?: number | null;
  accountbalance?: number | null;
  mainAccountName?: string | null;
  sender_id?: string | null;
  senderName?: string | null;
  senderPhone?: string | null;
  recipient_id?: string | null;
  recipientName?: string | null;
  recipientPhone?: string | null;
  createddate_myanmar?: string | null;
  ClinicCode?: string | null;
  ClinicName?: string | null;
}

export interface WalletTransactionsResponse {
  data: WalletTransactionRow[];
  totalCount: number;
}

export interface GetWalletTransactionsByClinicData {
  getWalletTransactionsByClinic: WalletTransactionsResponse | null;
}

export interface GetWalletTransactionsData {
  getWalletTransactions: WalletTransactionsResponse | null;
}

export interface WalletSummary {
  totalIn: number;
  totalOut: number;
  transactionCount: number;
  balance: number;
}

export interface GetWalletSummaryData {
  getWalletSummary: WalletSummary | null;
}

export function getWalletSummaryVar(args: {
  clinicCode: string;
  fromDate?: string | null;
  toDate?: string | null;
}) {
  const { clinicCode, fromDate, toDate } = args;
  return {
    clinicCode,
    ...(fromDate != null && fromDate !== "" ? { fromDate } : {}),
    ...(toDate != null && toDate !== "" ? { toDate } : {}),
  };
}

export function getWalletTransactionsByClinicVar(args: {
  clinicCode: string;
  skip?: number;
  take?: number;
  fromDate?: string | null;
  toDate?: string | null;
}) {
  const { clinicCode, skip = 0, take = 20, fromDate, toDate } = args;
  return {
    clinicCode,
    skip,
    take,
    ...(fromDate != null && fromDate !== "" ? { fromDate } : {}),
    ...(toDate != null && toDate !== "" ? { toDate } : {}),
  };
}

export function getWalletTransactionsVar(args: {
  clinicCode: string;
  skip?: number;
  take?: number;
  fromDate?: string | null;
  toDate?: string | null;
}) {
  return getWalletTransactionsByClinicVar(args);
}
